(() => {
  if (customElements.get('facet-drawer-controller')) return;

  class FacetDrawerController extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('[data-facet-drawer]');
      if (!this.details) return;
      this.trigger = this.details.querySelector('.facet-drawer__trigger');
      this.panel = this.details.querySelector('[data-facet-panel]');
      this.media = window.matchMedia('(max-width: 989px)');
      this.originalOverflow = '';
      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onResize = this.onResize.bind(this);
      this.details.addEventListener('toggle', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onPointerDown);
      this.media.addEventListener('change', this.onResize);
      this.onResize();
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onPointerDown);
      this.media?.removeEventListener('change', this.onResize);
      this.unlock();
    }

    onResize() {
      if (!this.media.matches) {
        this.unlock();
        this.details.removeAttribute('role');
        this.details.removeAttribute('aria-modal');
        this.details.open = true;
      } else {
        this.details.open = false;
        this.unlock();
      }
    }

    onToggle() {
      if (!this.media.matches || !this.details.open) {
        this.unlock();
        this.details.removeAttribute('role');
        this.details.removeAttribute('aria-modal');
        return;
      }
      this.originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.details.setAttribute('role', 'dialog');
      this.details.setAttribute('aria-modal', 'true');
      this.details.setAttribute('aria-label', this.trigger.querySelector('.facet-drawer__open-label').textContent.trim());
      this.trigger.focus();
    }

    unlock() {
      if (this.originalOverflow !== null) {
        document.body.style.overflow = this.originalOverflow;
        this.originalOverflow = null;
      }
    }

    close() {
      if (!this.details.open || !this.media.matches) return;
      this.details.open = false;
      this.trigger.focus();
    }

    onPointerDown(event) {
      if (!this.details.open || !this.media.matches) return;
      if (this.panel.contains(event.target) || this.trigger.contains(event.target)) return;
      event.preventDefault();
      this.close();
    }

    onKeydown(event) {
      if (!this.details.open || !this.media.matches) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const controls = [this.trigger, ...this.panel.querySelectorAll('a, button, input, select, summary, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.disabled && element.getClientRects().length > 0);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('facet-drawer-controller', FacetDrawerController);
})();
